import {
  OwnerIdSortEnum,
  OwnerNameSortEnum,
  OwnerRegistrationNumberSortEnum,
  QueryKeyLocalStorageEnum,
} from 'context/query/queryContext/QueryContext.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { useLocaleStoreQuery } from 'hooks/useLocaleStoreQuery/useLocaleStoreQuery';
import { AppMessages } from 'i18n/messages';
import { Table } from 'ui/table/Table';
import { OrganizationsTreeSelect } from 'ui/organizationsTreeSelect/OrganizationsTreeSelect';

import { PositionGroupAssignedOwnersHeaderItem } from './positionOwnersHeaderItem/PositionGroupAssignedOwnersHeaderItem';

export const GroupAssignedOwnersTableHeader = () => {
  const { formatMessage } = useLocale();

  const {
    storedQueries: { groupAssignedOwners: groupAssignedOwnersQuery },
    setQuery,
  } = useLocaleStoreQuery();

  return (
    <>
      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.GROUP_ASSIGNED_OWNERS}
        sortBy={OwnerIdSortEnum}
        queryHeader={formatMessage({ id: AppMessages['owners.header.id'] })}
      />

      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.GROUP_ASSIGNED_OWNERS}
        sortBy={OwnerNameSortEnum}
        queryHeader={formatMessage({ id: AppMessages['owners.header.fullName'] })}
      />

      <OrganizationsTreeSelect
        multiple
        isFilterType
        onChange={(options) =>
          options &&
          setQuery(QueryKeyLocalStorageEnum.GROUP_ASSIGNED_OWNERS, {
            ...groupAssignedOwnersQuery,
            komorka: options.map((cell) => cell.id),
          })
        }
        value={groupAssignedOwnersQuery.komorka?.map((id) => ({ id, nazwa: 'komorka' }))}
        placeholder={formatMessage({ id: AppMessages['owners.header.cell'] })}
      />

      <PositionGroupAssignedOwnersHeaderItem>
        {formatMessage({ id: AppMessages['owners.header.position'] })}
      </PositionGroupAssignedOwnersHeaderItem>

      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.GROUP_ASSIGNED_OWNERS}
        sortBy={OwnerRegistrationNumberSortEnum}
        queryHeader={formatMessage({ id: AppMessages['owners.header.registrationNumber'] })}
      />
    </>
  );
};
